import { render, staticRenderFns } from "./LinkExpiration.vue?vue&type=template&id=0d414e6c&scoped=true&"
import script from "./LinkExpiration.vue?vue&type=script&lang=js&"
export * from "./LinkExpiration.vue?vue&type=script&lang=js&"
import style0 from "./LinkExpiration.vue?vue&type=style&index=0&id=0d414e6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d414e6c",
  null
  
)

/* custom blocks */
import block0 from "./LinkExpiration.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d414e6c')) {
      api.createRecord('0d414e6c', component.options)
    } else {
      api.reload('0d414e6c', component.options)
    }
    module.hot.accept("./LinkExpiration.vue?vue&type=template&id=0d414e6c&scoped=true&", function () {
      api.rerender('0d414e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/steps/Link/LinkExpiration.vue"
export default component.exports